import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { AssessmentService } from '../../services/assessment-service/assessment.service';
import { UserContextService } from '../../services/user-context-service/user-context.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  imports: [CommonModule, RouterModule, TranslateModule, FormsModule, ReactiveFormsModule],
})
export class ConfirmComponent implements OnInit {
  confirmForm: FormGroup;
  isDisableable: boolean = false;
  insuredPersonFullName: string;
  private activeAssessmentId: string = '';
  private language: string = 'en';

  constructor(
    private readonly assessmentService: AssessmentService,
    private readonly appConfigService: AppConfigService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userContextService: UserContextService
  ) {}

  ngOnInit(): void {
    this.confirmForm = new FormGroup({
      hasDeclaredAccuracy: new FormControl(false, [Validators.requiredTrue]),
      hasConfirmed: new FormControl(false, [Validators.requiredTrue]),
    });
    this.isDisableable = this.appConfigService.configData?.rspButtonShouldBeDisabled ?? true;
    this.activeAssessmentId = this.route.snapshot.paramMap.get('assessmentId');
    this.language = this.route.snapshot.paramMap.get('lang');
    this.insuredPersonFullName = this.userContextService.getInsuredPersonFullNameForAssessmentWrapper(
      this.assessmentService.getCurrentAssessmentWrapperId()
    );
  }

  confirm() {
    if (this.confirmForm.invalid) {
      this.confirmForm.markAllAsTouched();
      return;
    }
    this.assessmentService.confirm(this.assessmentService.getCurrentAssessmentWrapperId()).subscribe(() => {
      if (this.appConfigService.featureToggles?.showSigningPage && this.appConfigService.featureToggles?.documentCreationEnabled) {
        this.router.navigate(['/sign', this.activeAssessmentId, { lang: this.language }]).then();
      } else {
        this.router.navigate(['/result']).then();
      }
    });
  }

  goBack(): void {
    this.assessmentService.resetAssessmentToModifyState(this.assessmentService.getCurrentAssessmentWrapperId()).subscribe({
      next: () => {
        this.router.navigate(['/assessment', this.activeAssessmentId, { lang: this.language, readonly: true }]).then();
      },
      error: e => {
        this.router.navigate(['/error']).then();
      },
      complete: () => {},
    });
  }
}
